import React, { useEffect } from "react";
import { Form, Col, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { customValidators, object, string } from '../../../Helpers/Validators/customValidators';
import { TextInput, RadioInput, AutocompleteInput, SelectInput, StyledRadioInput } from "../../../Helpers/Inputs";
import { NumberFormatDecimal, InputMaskPhone, InputMaskZip } from '../../../Helpers/Formatters';
import Occupations from '../Helpers/Occupations';
import * as States from '../../../Helpers/Constants/States';
import StatesWithDisabled from '../../../Helpers/Lists/StatesWithDisabled';
import LicenseReasons from '../Helpers/LicenseReasons';
import Step3Icon from '../icons/step_3.svg';
import InfoIcon from '@material-ui/icons/Info';
import { withStyles, Tooltip } from '@material-ui/core';
import IconHolder from "../../../Helpers/IconHolder";
import { SESSION_STORAGE_ANALYSIS_KEY, getSessionStorageItem } from "../../../../sessionStorage";
export default function IdentityVerification(props) {

  const { register, errors, setValue, triggerValidation } = props;
  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };

  const handleChangeState = (field, value, driverLicenseNumber) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
    if (driverLicenseNumber !== "") {
      triggerValidation('driverLicenseNumber');
    }
  };

  useEffect(() => {
    register({ name: 'occupation' });
    setValue('occupation', props.formState.occupation);

    register({ name: 'secondaryAddresseePhoneNumberType' });
    setValue('secondaryAddresseePhoneNumberType', props.formState.secondaryAddresseePhoneNumberType);

    register({ name: 'secondaryAddresseeState' });
    setValue('secondaryAddresseeState', props.formState.secondaryAddresseeState);

    register({ name: 'state' });
    setValue('state', props.basicInfo.state);

    register({ name: 'driverLicenceState' });
    setValue('driverLicenceState', props.formState.driverLicenceState);

    register({ name: 'validDriverLicense' });
    setValue('validDriverLicense', props.formState.validDriverLicense);

    register({ name: 'includeSecondaryAdressee' });
    setValue('includeSecondaryAdressee', props.formState.includeSecondaryAdressee);
  }, [register]);

  useEffect(() => {
    if(props.formState.annualSalary === null || props.formState.annualSalary === ""){
      const analysisInfo = getSessionStorageItem(SESSION_STORAGE_ANALYSIS_KEY);
      props.onFieldChange('annualSalary', analysisInfo && analysisInfo.annualIncome);
    }
  }, []);

  const occupations = Occupations();
  const licenseReasons = LicenseReasons();

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: 14,
      boxShadow: theme.shadows[1],
    },
  }))(Tooltip);

  const label = (<span>Designate another person the right to receive notice of an impending lapse or termination of the policy applied for in the event of nonpayment of premium?
    <LightTooltip title="This is to ensure that your life insurance policy doesn’t lapse unintentionally." placement="top" enterTouchDelay={0} ><InfoIcon className="ml-2" /></LightTooltip>
  </span>);

  return (
          <React.Fragment>
          <Row className="justify-content-center">
          <IconHolder icon={Step3Icon} viewBox="0 0 25 25" />
          </Row>
          <h4 className="headerTitle">Verifying Your Identification</h4>
          <h5 className="headerSubtitle">Your privacy and security are our first priority. This information is used solely to secure your best rate for coverage that you can buy online.</h5>

            <Form.Group>
              <RadioInput
                name="employmentStatus"
                id="employmentStatus"
                label="What is your current employment status?"
                value={props.formState.employmentStatus}
                radios={[
                  { value: "Employed", label: "Employed" },
                ]}
                onChange={e => handleValueChange('employmentStatus', e.target.value)}
                inputRef={register}
                errors={errors.employmentStatus}
                hideError
              />

              {props.formState.employmentStatus === "Employed" &&
                <div className="ml-4">
                  <Form.Group>
                    <TextInput
                      name="annualSalary"
                      id="annualSalary"
                      label="Annual Salary"
                      value={props.formState.annualSalary}
                      onChange={e => props.onFieldChange('annualSalary', e.target.value)}
                      errors={errors.annualSalary}
                      inputRef={register}
                      InputProps={{
                        inputComponent: NumberFormatDecimal,
                      }}
                    />
                  </Form.Group>

                  <Form.Group>
                    <AutocompleteInput
                      name="occupation"
                      id="occupation"
                      value={occupations.find(o => o.value === props.formState.occupation)}
                      onChange={(value) => handleValueChange('occupation', value)}
                      label="Occupation"
                      selectOptions={occupations}
                      errors={errors && errors.occupation}
                      inputRef={register}
                    />
                  </Form.Group>
                </div>
              }

              <RadioInput
                name="employmentStatus"
                id="employmentStatus"
                label=""
                value={props.formState.employmentStatus}
                radios={[
                  { value: "Unemployed", label: "Unemployed" },
                  { value: "Disabled", label: "Disabled" },
                  { value: "Student", label: "Student" },
                  { value: "Retired", label: "Retired" },
                  { value: "Stay-at-Home Person", label: "Stay-at-Home Person" },
                ]}
                onChange={e => handleValueChange('employmentStatus', e.target.value)}
                errors={errors.employmentStatus}
                inputRef={register}
                hideLabel
              />
            </Form.Group>

            <Form.Group>
              <StyledRadioInput
                name="validDriverLicense"
                id="validDriverLicense"
                label="Do you have a valid driver’s license?"
                value={props.formState.validDriverLicense}
                options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                onChange={e => handleValueChange('validDriverLicense', e)}
                errors={errors.validDriverLicense}
              />

              {props.formState.validDriverLicense === "true" &&
                <div>
                  <Form.Group>
                    <SelectInput
                      name="driverLicenceState"
                      id="driverLicenceState"
                      value={props.formState.driverLicenceState}
                      onChange={(e) => handleChangeState('driverLicenceState', e.target.value, props.formState.driverLicenseNumber)}
                      label="Driver's License State"
                      selectOptions={StatesWithDisabled(["NY"])}
                      errors={errors && errors.driverLicenceState}
                      inputRef={register}
                    />
                  </Form.Group>

                  <Form.Group>
                    <TextInput
                      name="driverLicenseNumber"
                      id="driverLicenseNumber"
                      label="Driver's License Number"
                      value={props.formState.driverLicenseNumber}
                      onChange={e => handleValueChange('driverLicenseNumber', e.target.value)}
                      errors={errors.driverLicenseNumber}
                      inputRef={register}
                      disabled={props.formState.driverLicenceState === ""}
                    />
                  </Form.Group>

                  <Form.Group>
                    <TextInput
                      name="driverLicenseName"
                      id="driverLicenseName"
                      label="Name on Driver's License"
                      value={props.formState.driverLicenseName}
                      onChange={e => props.onFieldChange('driverLicenseName', e.target.value)}
                      errors={errors.driverLicenseName}
                      inputRef={register}
                      disabled={props.formState.driverLicenceState === ""}
                    />
                  </Form.Group>

                </div>
              }

              {props.formState.validDriverLicense === "false" &&
                <Form.Group>
                  <SelectInput
                    id="noDrivingReason"
                    name="noDrivingReason"
                    value={props.formState.noDrivingReason}
                    onChange={e => handleValueChange('noDrivingReason', e.target.value)}
                    label="Choose a Reason"
                    selectOptions={licenseReasons}
                    errors={errors.noDrivingReason}
                    inputRef={register}
                  />
                </Form.Group>
              }

            </Form.Group>

            {isSecondaryAddresseeState(props.basicInfo.state) && (
              <React.Fragment>
                <Form.Group>
                  <StyledRadioInput
                    name="includeSecondaryAdressee"
                    id="includeSecondaryAdressee"
                    label={label}
                    value={props.formState.includeSecondaryAdressee}
                    options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                    onChange={e => handleValueChange('includeSecondaryAdressee', e)}
                    errors={errors.includeSecondaryAdressee}
                  />
                </Form.Group>

                {props.formState.includeSecondaryAdressee === "true" &&
                  <React.Fragment>
                    <Form.Group>
                      <TextInput
                        name="secondaryAddresseeFirstName"
                        id="secondaryAddresseeFirstName"
                        label="Designee First Name"
                        value={props.formState.secondaryAddresseeFirstName}
                        onChange={(e) => props.onFieldChange('secondaryAddresseeFirstName', e.target.value)}
                        errors={errors.secondaryAddresseeFirstName}
                        inputRef={register}
                      />
                    </Form.Group>

                    <Form.Group>
                      <TextInput
                        name="secondaryAddresseeMiddleName"
                        id="secondaryAddresseeMiddleName"
                        label="Designee Middle Name"
                        value={props.formState.secondaryAddresseeMiddleName}
                        onChange={(e) => props.onFieldChange('secondaryAddresseeMiddleName', e.target.value)}
                        errors={errors.secondaryAddresseeMiddleName}
                        inputRef={register}
                      />
                    </Form.Group>

                    <Form.Group>
                      <TextInput
                        name="secondaryAddresseeLastName"
                        id="secondaryAddresseeLastName"
                        label="Designee Last Name"
                        value={props.formState.secondaryAddresseeLastName}
                        onChange={(e) => props.onFieldChange('secondaryAddresseeLastName', e.target.value)}
                        errors={errors.secondaryAddresseeLastName}
                        inputRef={register}
                      />
                    </Form.Group>

                    <Form.Group>
                      <SelectInput
                        name="secondaryAddresseePhoneNumberType"
                        id="secondaryAddresseePhoneNumberType"
                        label="Designee Phone Number Type"
                        value={props.formState.secondaryAddresseePhoneNumberType}
                        selectOptions={[{ value: "home", label: "Home" }, { value: "cell", label: "Cell" }, { value: "work", label: "Work" }]}
                        onChange={e => handleValueChange('secondaryAddresseePhoneNumberType', e.target.value)}
                        errors={errors.secondaryAddresseePhoneNumberType}
                        inputRef={register}
                      />
                    </Form.Group>

                    <Form.Group>
                      <TextInput
                        name="secondaryAddresseePhoneNumber"
                        id="secondaryAddresseePhoneNumber"
                        label="Designee Phone Number"
                        value={props.formState.secondaryAddresseePhoneNumber}
                        onChange={(e) => handleValueChange('secondaryAddresseePhoneNumber', e.target.value)}
                        errors={errors.secondaryAddresseePhoneNumber}
                        inputRef={register}
                        InputProps={{
                          inputComponent: InputMaskPhone,
                        }}
                      />
                    </Form.Group>

                    <Form.Group>
                      <TextInput
                        name="secondaryAddresseeAddress"
                        id="secondaryAddresseeAddress"
                        label="Designee Address"
                        value={props.formState.secondaryAddresseeAddress}
                        onChange={e => props.onFieldChange('secondaryAddresseeAddress', e.target.value)}
                        errors={errors.secondaryAddresseeAddress}
                        inputRef={register}
                      />
                    </Form.Group>

                    <Form.Group>
                      <TextInput
                        name="secondaryAddresseeCity"
                        id="secondaryAddresseeCity"
                        label="Designee City"
                        value={props.formState.secondaryAddresseeCity}
                        onChange={e => props.onFieldChange('secondaryAddresseeCity', e.target.value)}
                        errors={errors.secondaryAddresseeCity}
                        inputRef={register}
                      />
                    </Form.Group>

                    <Row>
                      <Col>
                        <Form.Group>
                          <SelectInput
                            name="secondaryAddresseeState"
                            id="secondaryAddresseeState"
                            label="Designee State"
                            value={props.formState.secondaryAddresseeState}
                            onChange={e => handleValueChange('secondaryAddresseeState', e.target.value)}
                            errors={errors && errors.secondaryAddresseeState}
                            inputRef={register}
                            selectOptions={StatesWithDisabled(["NY"])}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group>
                          <TextInput
                            name="secondaryAddresseeZip"
                            id="secondaryAddresseeZip"
                            label="Designee Zip"
                            value={props.formState.secondaryAddresseeZip}
                            onChange={e => props.onFieldChange('secondaryAddresseeZip', e.target.value)}
                            errors={errors.secondaryAddresseeZip}
                            inputRef={register}
                            InputProps={{
                              inputComponent: InputMaskZip,
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </React.Fragment>
                }

              </React.Fragment>
            )}
          </React.Fragment>
  );
}

const isSecondaryAddresseeState = (state) => {
  if (state === States.CONNECTICUT ||
    state === States.IDAHO ||
    state === States.MAINE ||
    state === States.MONTANA ||
    state === States.RHODE_ISLAND ||
    state === States.UTAH ||
    state === States.VERMONT ||
    state === States.CALIFORNIA ||
    state === States.FLORIDA
  ) {
    return true;
  }
  return false;
};

IdentityVerification.ValidationSchema = object().shape({
  employmentStatus: string()
    .required('This field is required.'),
  annualSalary: string().when('employmentStatus', {
    is: "Employed",
    then: string().required('Annual Salary is required.'),
    otherwise: string().notRequired()
  }),
  occupation: string().when('employmentStatus', {
    is: "Employed",
    then: string().required('Occupation is required.'),
    otherwise: string().notRequired()
  }),
  validDriverLicense: string().required('Must provide an answer.'),
  noDrivingReason: string().when('validDriverLicense', {
    is: "false",
    then: string().required('Please select an option.'),
    otherwise: string().notRequired()
  }),
  driverLicenceState: string().when('validDriverLicense', {
    is: "true",
    then: string().required("Driver's License State is required."),
    otherwise: string().notRequired()
  }),
  driverLicenseNumber: string().when('validDriverLicense', {
    is: "true",
    then: string().when("driverLicenceState", (driverLicenceState) => {
      return customValidators.string().ValidateDriversLicense('Invalid format for selected state.', driverLicenceState).required("Driver's License Number is required.");
    }),
    otherwise: string().notRequired()
  }),
  driverLicenseName: string().when('validDriverLicense', {
    is: "true",
    then: customValidators.string().isValidNameLimitedSpecialChar("Name on Driver's License is required.", true, false),
    otherwise: string().notRequired()
  }),
  includeSecondaryAdressee: string().when('state', {
    is: state => isSecondaryAddresseeState(state) === true,
    then: string().required('This field is required.'),
    otherwise: string().notRequired()
  }),
  secondaryAddresseeFirstName: string().when(['state', 'includeSecondaryAdressee'], {
    is: (state, includeSecondaryAdressee) => isSecondaryAddresseeState(state) === true && includeSecondaryAdressee === "true",
    then: customValidators.string().isValidNameLimitedSpecialChar('First Name is required.', true, false),
    otherwise: string().notRequired()
  }),
  secondaryAddresseeMiddleName: string()
    .matches(/^$|^(?!\s*$)[ a-zA-ZÀ-ÖØ-öø-ÿ'.-]{1}$/, 'Must be single alpha character.')
    .notRequired(),
  secondaryAddresseeLastName: string().when(['state', 'includeSecondaryAdressee'], {
    is: (state, includeSecondaryAdressee) => isSecondaryAddresseeState(state) === true && includeSecondaryAdressee === "true",
    then: customValidators.string().isValidNameLimitedSpecialChar('Last Name is required.', true, false),
    otherwise: string().notRequired()
  }),
  secondaryAddresseePhoneNumberType: string().when(['state', 'includeSecondaryAdressee'], {
    is: (state, includeSecondaryAdressee) => isSecondaryAddresseeState(state) === true && includeSecondaryAdressee === "true",
    then: string().required('Phone Number Type is required.'),
    otherwise: string().notRequired()
  }),
  secondaryAddresseePhoneNumber: string().when(['state', 'includeSecondaryAdressee'], {
    is: (state, includeSecondaryAdressee) => isSecondaryAddresseeState(state) === true && includeSecondaryAdressee === "true",
    then: customValidators.string()
      .required('Phone Number is required.')
      .isValidPhone('Phone Number must be formatted as "(123) 456-7890".'),
    otherwise: string().notRequired()
  }),
  secondaryAddresseeAddress: string().when(['state', 'includeSecondaryAdressee'], {
    is: (state, includeSecondaryAdressee) => isSecondaryAddresseeState(state) === true && includeSecondaryAdressee === "true",
    then: customValidators.string().isValidAddress('Invalid address. No special character is allowed').required('Address is required.'),
    otherwise: string().notRequired()
  }),
  secondaryAddresseeCity: string().when(['state', 'includeSecondaryAdressee'], {
    is: (state, includeSecondaryAdressee) => isSecondaryAddresseeState(state) === true && includeSecondaryAdressee === "true",
    then: string().required('City is required.'),
    otherwise: string().notRequired()
  }),
  secondaryAddresseeState: string().when(['state', 'includeSecondaryAdressee'], {
    is: (state, includeSecondaryAdressee) => isSecondaryAddresseeState(state) === true && includeSecondaryAdressee === "true",
    then: string().required('State is required.'),
    otherwise: string().notRequired()
  }),
  secondaryAddresseeZip: string().when(['state', 'includeSecondaryAdressee'], {
    is: (state, includeSecondaryAdressee) => isSecondaryAddresseeState(state) === true && includeSecondaryAdressee === "true",
    then: customValidators.string()
      .required()
      .isValidNumbersOnly('Invalid zip.', 5),
    otherwise: string().notRequired()
  }),
});

IdentityVerification.DefaultFormState = (prefill = false, basicInfo = null, analysisInfo = null) => {
  return {
    employmentStatus: prefill ? "Employed" : "",
    annualSalary: prefill ? "51525" : basicInfo && basicInfo.income || analysisInfo && analysisInfo.annualIncome || "",
    occupation: prefill ? "1" : "",
    validDriverLicense: prefill ? "false" : "",
    noDrivingReason: prefill ? "I use public or commercial transportation" : "",
    driverLicenseName: prefill ? "Proposed N Sured" : "",
    driverLicenceState: prefill ? "MA" : "",
    driverLicenseNumber: prefill ? "123a4567b" : "",
    includeSecondaryAdressee: prefill ? "false" : "",
    secondaryAddresseeFirstName: prefill ? "Proposed" : "",
    secondaryAddresseeMiddleName: prefill ? "N" : "",
    secondaryAddresseeLastName: prefill ? "Sured" : "",
    secondaryAddresseePhoneNumberType: prefill ? "home" : "",
    secondaryAddresseePhoneNumber: prefill ? "(123) 345-4567" : "",
    secondaryAddresseeAddress: prefill ? "123 Main Street" : "",
    secondaryAddresseeCity: prefill ? "Boston" : "",
    secondaryAddresseeState: prefill ? "MA" : "",
    secondaryAddresseeZip: prefill ? "02110" : "",
  };
};

IdentityVerification.propTypes = {
  formState: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  register: PropTypes.func,
  errors: PropTypes.object,
  setValue: PropTypes.func,
  triggerValidation: PropTypes.func,
  basicInfo: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/steps/IdentityVerification.js